module.exports = __webpack_public_path__ + "static/media/img-confirm.b01de49b.png";